<template>
  <Webview>
    <Header title="註冊" :back="back"></Header>
    <div class="register_page _fill">
      <div class="logo">
        <img src="./img/logo.svg">
      </div>
      <div class="form">
        <template v-for="(item, key) in form">
          <Control :passData="item" :update="update" :check="check"></Control>
        </template>
      </div>
    </div>
    <div class="wv_button">
      <div class="main_btn _main" @click="submit">{{$tp("label.ok")}}</div>
    </div>
    <!-- Otp -->
    <template v-if="currentPage === 'register_otp'">
      <Otp :email="email" :back="()=>toPage('current')" :submit="login" />
    </template>
  </Webview>
</template>

<script>
//api
import { otpRegister } from "@/api/auth";
export default {
  mixins: [
    require("@mix/form").default,
    require("./mixins/formData").default
  ],
  computed: {
    ...mapGetters(["notifyToken", "token"]),
    currentPage() { return this.$route.name }
  },
  methods: {
    back() {
      this.$router.replace({ path: "/login" });
    },
    toPage(type) {
      switch (type) {
        case "otp": this.$router.push({ name: "register_otp" }); break; //輸入個人資料後, 跳轉至收信輸入驗證碼 register_otp 頁面
        case "current": this.$router.push({ name: "register" }); break; //在 register_otp 頁面時,按下返回回到 register 頁面
      }
    },
    async submit() {
      this.checkAll();
      if (!this.isAllValid) return false;

      await this.register();
    },
    async register() {
      try {
        const params = {
          name: this.name,
          email: this.email,
          phoneNum: this.phoneNum
        }

        await otpRegister(params);

        this.$router.replace({ path: "/register/otp" })
      }
      catch (error) {
        NOTIFICATION("e", error?.message || this.$tp("slot.failed", { label: this.$tp("label.register") }));
      }
    },
    async login(otp) {
      await this.$store.dispatch("OtpLogin", { email: this.email, otp: otp });

      //不要動, 只有一般 .vue 才有 this
      this.$router.replace({ path: "/channel" });
    }
  }
}
</script>

<style lang="scss" scoped>
.register_page {
  padding: 2rem $main_P;

  @media (max-height: 550px) {
    padding: 1.5rem $main_P;
  }

  @media (max-height: 500px) {
    padding: 1rem $main_P;
  }

  .logo {
    max-width: 16.7rem;
    margin: 0 auto;
    margin-bottom: 1.6rem;

    @media (max-height: 665px) {
      margin-bottom: 0rem;
    }

    @media (max-height: 640px) {
      max-width: 14rem;
    }

    @media (max-height: 620px) {
      max-width: 12rem;
    }

    @media (max-height: 600px) {
      display: none;
    }
  }
}
</style>